"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingService = function () {
  function LoadingService(blockUI, $timeout) {
    "ngInject";

    (0, _classCallCheck3.default)(this, LoadingService);
    this.blockUI = blockUI;
    this.$timeout = $timeout;
  }

  (0, _createClass3.default)(LoadingService, [{
    key: "showLoading",
    value: function showLoading(instanceId, msg) {
      var blockInstance = this.blockUI.instances.get(instanceId);

      blockInstance.start(msg);
    }
  }, {
    key: "hideLoading",
    value: function hideLoading(instanceId) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;

      var blockInstance = this.blockUI.instances.get(instanceId);

      if (delay === 0) {
        blockInstance.stop();
      } else {
        this.$timeout(function () {
          blockInstance.stop();
        }, delay);
      }
    }
  }]);
  return LoadingService;
}();

exports.default = LoadingService;


// WEBPACK FOOTER //
// ./client/app/common/services/loadingService.js